import React from 'react';
import cx from 'classnames';
import { Icon, Text } from '../../../ui-kit';
import '../styles/_placeholder.scss';

const TEXT_SIZE = {
  MEDIUM: 1000,
  SMALL: 600
};











export default function VideoPlaceholder(
{ text, icon, iconColor, subtitle, darkTheme, className, size: { width } })
{
  return (
    <div className={cx('video-placeholder', { 'video-placeholder--dark': darkTheme }, className)}>
      <Icon className="video-placeholder__icon" name={icon} color={iconColor} animated />

      <div className="video-placeholder__text">
        <Text
          heading3={width >= TEXT_SIZE.MEDIUM}
          heading4={width < TEXT_SIZE.MEDIUM && width >= TEXT_SIZE.SMALL}
          heading5={width < TEXT_SIZE.SMALL}
          noMargin="top"
          darkTheme>

          {text}
        </Text>

        {subtitle ? <Text label={width < TEXT_SIZE.SMALL} darkTheme>{subtitle}</Text> : null}
      </div>
    </div>);

}

VideoPlaceholder.defaultProps = {
  text: 'Preparing',
  icon: 'rushedit',
  iconColor: 'monkey'
};